// extracted by mini-css-extract-plugin
module.exports = {"checkListItem":"iS","checkListIconWrapper":"iT","checkListIcon":"iU","checkListText":"iV"};